import { render, staticRenderFns } from "./ParagraphList.vue?vue&type=template&id=50c84311&"
import script from "./ParagraphList.vue?vue&type=script&lang=js&"
export * from "./ParagraphList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports